export default __webpack_public_path__ + "163550a6fc7a2f8528029a17a4eea53e.png";